import { render, staticRenderFns } from "./TablePaginatedEstimationsComplex.vue?vue&type=template&id=62586689&scoped=true"
import script from "./TablePaginatedEstimationsComplex.vue?vue&type=script&lang=js"
export * from "./TablePaginatedEstimationsComplex.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedEstimationsComplex.vue?vue&type=style&index=0&id=62586689&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62586689",
  null
  
)

export default component.exports